export function inRange(n, start, end, includeLeft, includeRight) {
    if (includeLeft === void 0) { includeLeft = true; }
    if (includeRight === void 0) { includeRight = false; }
    if ((includeLeft && n === start) || (includeRight && n === end))
        return true;
    return n > start && n < end;
}
//# sourceMappingURL=in-range.js.map